'use strict';

const { getAffiliateURL } = require('./slug-helper');
const { subscribeOnce } = require('./event-observer');

const waitsLeft = [50, 150, 350, 750, 950];
const BackTabType = 'OnlineCode';

function waitOnEvent({
  doneCheck,
  callback,
  fallback,
  totalWaits = waitsLeft,
}) {
  const waiter = index => {
    const done = doneCheck();

    if (done) {
      return callback(done);
    }

    const wait = totalWaits[index];
    if (wait) {
      return setTimeout(() => waiter(index + 1), wait);
    }

    return fallback();
  };

  waiter(0);
}

function affiliateEvents() {
  const click = {};
  subscribeOnce('OFFER_DATA', ({ offerId, merchantId, referralSource }) => {
    click.offerId = offerId;
    click.merchantId = merchantId;
    click.referralSource = referralSource;
  });

  subscribeOnce('MERCHANT_DATA', ({ merchantId, referralSource }) => {
    click.merchantId = merchantId;
    click.referralSource = referralSource;
  });

  subscribeOnce('EVENT_ID', ({ eventId, type, isRedirect, isMerchant }) => {
    click.eventId = eventId;
    click.type = type;
    click.isMerchant = isMerchant;

    if (type !== BackTabType || isRedirect) {
      const affiliateURL = getAffiliateURL(click);

      window.open(affiliateURL.href, '_blank');
    }
  });

  subscribeOnce('REDEMPTION_DATA', () => {
    if (click.type === BackTabType) {
      const affiliateURL = getAffiliateURL(click);

      window.location.assign(affiliateURL.href);
    }
  });
}

module.exports = {
  waitOnEvent,
  affiliateEvents,
};
